import { ActionType } from 'typesafe-actions';
import { call, put, select, take, takeLeading, takeEvery } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';

import * as actions from 'store/actions/users';
import { IStore } from 'store/reducers';
import { User } from 'models/User';
import Endpoints from 'endpoints';
import { LoggedUserResponse } from 'store/types/users';

import GipsyApi from 'apis/GipsyGDS';
import { request } from './api';

function* getUser(action: ActionType<typeof actions.getUser.request>) {
  try {
    const response = yield call(request, {
      method: 'get',
      url: Endpoints.accountDetailsPath(),
    });

    localStorage.setItem('userData', JSON.stringify(response.data));

    yield call(resolvePromiseAction, action, response.data);
    yield put(actions.getUser.success(response.data));
  } catch (err) {
    yield call(rejectPromiseAction, action, err);
    yield put(actions.getUser.failure());
  }
}

function* restoreUserData() {
  const token = yield select((state: IStore) => state.auth.token);

  if (!token) {
    localStorage.removeItem('userData');
    return;
  }

  const userData: string | null = localStorage.getItem('userData');
  let user: User | null;

  if (!userData) {
    user = null;
  } else {
    user = JSON.parse(userData) as User;
  }

  if (user) {
    yield put(actions.getUser.success(user));
  } else {
    yield put(actions.getUser.request());
    yield take(actions.getUser.success);
  }
}

function* loggedInUser(action: ActionType<typeof actions.loggedInUser.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: LoggedUserResponse } } = yield GipsyApi.get(Endpoints.loggedInUser(), {
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield call(resolvePromiseAction, action, response.data.data);
    yield put(actions.loggedInUser.success(response.data.data));
  } catch (err) {
    yield call(rejectPromiseAction, action, err);
    yield put(actions.loggedInUser.failure());
  }
}

export const watchUser = [
  takeLeading(actions.getUser.request, getUser),
  takeLeading(actions.restoreUserData.request, restoreUserData),
  takeLeading(actions.loggedInUser.request, loggedInUser),
];
